import { render, staticRenderFns } from "./ColumnIndex.vue?vue&type=template&id=621b17e7&"
import script from "./ColumnIndex.vue?vue&type=script&lang=js&"
export * from "./ColumnIndex.vue?vue&type=script&lang=js&"
import style0 from "./ColumnIndex.vue?vue&type=style&index=0&id=621b17e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports